export const FREE_CREDIT_BYTES = 100 * 1024 // 102400 bytes
